import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import fr from 'vuetify/src/locale/fr'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#d45050',
        secondary: '#333336',
        orlando: '#76b729'
      }
    }
  },
  lang: {
    locales: { fr },
    current: 'fr'
  }
})
